import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryLetterText from "../../texts/glossaryScreen/GlossaryLetterText";
import GlossaryTermItem from "../../items/glossaryScreen/GlossaryTermItem";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";

export default function GlossaryTermsByLetterList({terms, letter, refs, highlight, search}) {
    // Used in GlossaryContent as a shortcut to specific letter related content

    // BUILD
    if (isNullOrUndefined(terms))
        return null
    return (
        <div className={"w-full flex flex-col mt-[12px]"}
             ref={(el) => (refs.current[letter] = el)} >
            <GlossaryLetterText letter={letter} />
            <SystemCustomDivider color={"bg-greyLight7"}
                                 extraClass={"mt-[4px]"} />
            <div className={"w-full flex flex-col"}>
                {terms[letter].map((term, index) => (
                    <GlossaryTermItem key={index}
                                      isFirst={index === 0}
                                      term={term} search={search}
                                      highlight={highlight} />
                ))}
            </div>
        </div>
    );
}